// removed by extract-text-webpack-plugin
module.exports = {"form":"form-4HXev","header":"header-sQqTb","btn":"btn-1K5Ql btn-3FsRe"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/login-form/style.scss
 ** module id = 110
 ** module chunks = 0
 **/